<template>
	<v-container class="d-flex flex-column align-center justify-center">
		<div class="text-h2">Select a station</div>
	</v-container>
</template>

<script>
export default {
	name: "NoStationSelectedContainer"
}
</script>

<style lang="scss" scoped>
.v-container {
	height: 100%;
	color: $grey-400;
}
</style>